import { render, staticRenderFns } from "./AnimationPlayer.vue?vue&type=template&id=40ffaf87&scoped=true&"
import script from "./AnimationPlayer.js?vue&type=script&lang=js&"
export * from "./AnimationPlayer.js?vue&type=script&lang=js&"
import style0 from "./AnimationPlayer.scss?vue&type=style&index=0&id=40ffaf87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ffaf87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
